module.exports = __webpack_public_path__ + "static/media/arsmaquettepro-regular.f41fc134.woff";